// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration

const firebaseConfig = {
  //apiKey: "AIzaSyDhKaU4TpOEvl5Rjy03vh5NrKLzPN7iWX4",
  //authDomain: "raspberry-inspections-test.firebaseapp.com",
  //databaseURL: "https://raspberry-inspections-test.firebaseio.com",
  //projectId: "raspberry-inspections-test",
  //storageBucket: "raspberry-inspections-test.appspot.com",
  //messagingSenderId: "100041102176",
  appId: "1:100041102176:web:c7ff6a79687d4e03",

  apiKey: 'AIzaSyC9KJocijo6FRMfDqLEyfvzobxDaVR-M7I',
  authDomain: 'raspberryone-5cfa1.firebaseapp.com',
  databaseURL: 'https://raspberryone-5cfa1.firebaseio.com',
  projectId: 'raspberryone-5cfa1',
  storageBucket: 'raspberryone-5cfa1.appspot.com',
  messagingSenderId: '263766059273',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
